/** postMessage type emitted by WaaS when the shopper picks card/bank (Meld/Stripe). */
export const CHECKOUT_ONRAMP_METHOD_SELECTED = "checkout_onramp_method_selected";

/** postMessage type emitted by WaaS when it refused a second payment because one is already pending. */
export const CHECKOUT_ONRAMP_PAYMENT_IN_PROGRESS = "checkout_onramp_payment_in_progress";

/**
 * embedMessageAction maps a postMessage from the WaaS embed to what the add-funds page does:
 *  - "method_selected":     the shopper is leaving for a provider
 *  - "payment_in_progress": a payment is already pending — lock onto the in-progress state
 *  - null:                  not ours (unknown type, or an origin other than the embed's)
 */
export function embedMessageAction(event, allowedOrigin) {
  const type = event?.data?.type;
  if (type !== CHECKOUT_ONRAMP_METHOD_SELECTED && type !== CHECKOUT_ONRAMP_PAYMENT_IN_PROGRESS) {
    return null;
  }
  if (allowedOrigin && event.origin !== allowedOrigin) {
    return null;
  }
  return type === CHECKOUT_ONRAMP_PAYMENT_IN_PROGRESS ? "payment_in_progress" : "method_selected";
}
